import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ApmModule } from '@elastic/apm-rum-angular';
import { TranslateService } from '@ngx-translate/core';

import { LANGUAGE } from '@valk-nx/core/lib/core';
import { SbWrapperComponent } from '@valk-nx/storyblok/components/wrapper/src/lib/wrapper.component';

@Component({
	selector: 'valk-content-root',
	templateUrl: './app.component.html',
	imports: [RouterOutlet, ApmModule, SbWrapperComponent],
	providers: [],
})
export class AppComponent {
	private readonly translate = inject(TranslateService);
	private readonly language = inject(LANGUAGE);

	constructor() {
		this.translate.setFallbackLang(this.language);
		this.translate.use(this.language);
	}
}
